// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconColumn {
    width: 40px;
    background-color: rgb(229,229,229);
    transition: transform 0.07s ease-in;
    -o-transition: margin-right 0.07s ease-in;
    -ms-transition: margin-right 0.07s ease-in;
    -moz-transition: margin-right 0.07s ease-in;
    -webkit-transition: margin-right 0.07s ease-in;
}

.textColumn {
    position: absolute;
    top: 0px;
    left: 40px;
    bottom: 0px;
    z-index: 1;
    transform: scaleX(0);
    background-color: rgb(229,229,229);
    overflow: hidden;
    transform-origin: left;
    transition: transform 0.07s ease-in;
    -o-transition: transform 0.07s ease-in;
    -ms-transition: transform 0.07s ease-in;
    -moz-transition: transform 0.07s ease-in;
    -webkit-transition: transform 0.07s ease-in;
}

.mainDIV.alignToRight {
    flex-direction: row-reverse;
}

.mainDIV.alignToRight .textColumn {
    left: initial;
    right: 40px;
    transform-origin: right;
}

.mainDIV.alignToRight .expandButton {
    right: initial;
    left: 0px;
}

.mainDIV.alignToRight .textColumn .textDiv {
    justify-content: flex-end;
}

    .mainDIV.alignToRight .textColumn .textDiv span {
        margin-left: 10px;
        margin-right: 0px;
    }


.buttonDIV.overlayState .textColumn {
    transition-delay: 0.6s;
    -o-transition-delay: 0.6s;
    -ms-transition-delay: 0.6s;
    -moz-transition-delay: 0.6s;
    -webkit-transition-delay: 0.6s;
}

.buttonDIV.hover .textColumn,
.buttonDIV.expandedState .textColumn,
.buttonDIV.expandedState .iconColumn {
    transition-duration: 0.25s;
    -o-transition-duration: 0.25s;
    -ms-transition-duration: 0.25s;
    -moz-transition-duration: 0.25s;
    -webkit-transition-duration: 0.25s;
    transform: none;
}

.textColumn .textDiv {
    height: 40px;
}

        .textColumn .textDiv span {
            white-space: nowrap;
            margin-right: 10px;
        }

        .expandButton {
            position: absolute;
            right: 0px;
            top: 0px;
            height: 60px;
            z-index: 2;
        }

.placeHolder {
    height: 60px;
}

.contentDIV {
    display: none;
    height: 100%;
}

    .contentDIV.selectedContent {
        display: initial;
    }`, "",{"version":3,"sources":["webpack://./src/app/components/layouts/expansionpanel/expansion.panel.layout.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kCAAkC;IAClC,mCAAmC;IACnC,yCAAyC;IACzC,0CAA0C;IAC1C,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,kCAAkC;IAClC,gBAAgB;IAChB,sBAAsB;IACtB,mCAAmC;IACnC,sCAAsC;IACtC,uCAAuC;IACvC,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;IAEI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;;AAGJ;IACI,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;;;IAGI,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;QAEQ;YACI,mBAAmB;YACnB,kBAAkB;QACtB;;QAEA;YACI,kBAAkB;YAClB,UAAU;YACV,QAAQ;YACR,YAAY;YACZ,UAAU;QACd;;AAER;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;IAEI;QACI,gBAAgB;IACpB","sourcesContent":[".iconColumn {\n    width: 40px;\n    background-color: rgb(229,229,229);\n    transition: transform 0.07s ease-in;\n    -o-transition: margin-right 0.07s ease-in;\n    -ms-transition: margin-right 0.07s ease-in;\n    -moz-transition: margin-right 0.07s ease-in;\n    -webkit-transition: margin-right 0.07s ease-in;\n}\n\n.textColumn {\n    position: absolute;\n    top: 0px;\n    left: 40px;\n    bottom: 0px;\n    z-index: 1;\n    transform: scaleX(0);\n    background-color: rgb(229,229,229);\n    overflow: hidden;\n    transform-origin: left;\n    transition: transform 0.07s ease-in;\n    -o-transition: transform 0.07s ease-in;\n    -ms-transition: transform 0.07s ease-in;\n    -moz-transition: transform 0.07s ease-in;\n    -webkit-transition: transform 0.07s ease-in;\n}\n\n.mainDIV.alignToRight {\n    flex-direction: row-reverse;\n}\n\n.mainDIV.alignToRight .textColumn {\n    left: initial;\n    right: 40px;\n    transform-origin: right;\n}\n\n.mainDIV.alignToRight .expandButton {\n    right: initial;\n    left: 0px;\n}\n\n.mainDIV.alignToRight .textColumn .textDiv {\n    justify-content: flex-end;\n}\n\n    .mainDIV.alignToRight .textColumn .textDiv span {\n        margin-left: 10px;\n        margin-right: 0px;\n    }\n\n\n.buttonDIV.overlayState .textColumn {\n    transition-delay: 0.6s;\n    -o-transition-delay: 0.6s;\n    -ms-transition-delay: 0.6s;\n    -moz-transition-delay: 0.6s;\n    -webkit-transition-delay: 0.6s;\n}\n\n.buttonDIV.hover .textColumn,\n.buttonDIV.expandedState .textColumn,\n.buttonDIV.expandedState .iconColumn {\n    transition-duration: 0.25s;\n    -o-transition-duration: 0.25s;\n    -ms-transition-duration: 0.25s;\n    -moz-transition-duration: 0.25s;\n    -webkit-transition-duration: 0.25s;\n    transform: none;\n}\n\n.textColumn .textDiv {\n    height: 40px;\n}\n\n        .textColumn .textDiv span {\n            white-space: nowrap;\n            margin-right: 10px;\n        }\n\n        .expandButton {\n            position: absolute;\n            right: 0px;\n            top: 0px;\n            height: 60px;\n            z-index: 2;\n        }\n\n.placeHolder {\n    height: 60px;\n}\n\n.contentDIV {\n    display: none;\n    height: 100%;\n}\n\n    .contentDIV.selectedContent {\n        display: initial;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
